module.exports = __webpack_public_path__ + "media/images/lb/678-1e5a8fc4eb903518d717935c52cbc55b.svg";